import { sendRequest } from "../../hooks/requests/useRequest";

export async function getRequestBalance (dateStart, dateEnd, commercialLineId = null, clientId = null, status = null)
{
    const requestOptions = {
        method: "GET",
    };

    let url = `Reports/GetReportBalance/${dateStart}/${dateEnd}`;

    if (commercialLineId !== null) {
        url += `?commercial_line_id=${commercialLineId}`;
    }
    if (clientId !== null) {
        url += (commercialLineId !== null ? "&" : "?") + `id_company=${clientId}`;
    }    
    if (status !== null) {
        url += (commercialLineId !== null || clientId !== null ? "&" : "?") + `status=${status}`;
    }

    const response = await sendRequest(requestOptions, `${url}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function getRequestBalanceAccount (dateStart, dateEnd, commercialLineId = null, clientId = null)
{
    const requestOptions = {
        method: "GET",
    };

    let url = `Reports/GetReportAccountBalance/${dateStart}/${dateEnd}`;

    if (commercialLineId !== null) {
        url += `?commercial_line_id=${commercialLineId}`;
    }
    if (clientId !== null) {
        url += (commercialLineId !== null ? "&" : "?") + `id_company=${clientId}`;
    }    

    const response = await sendRequest(requestOptions, `${url}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}
